module.exports = "<div ui-view></div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/solidarity.module/features/solidarityRouting/solidarityRouting.html
// module id = 2241
// module chunks = 0